import { useQuery } from 'react-query';

import { getReportComments as queryFn } from 'api/endPoints/getReportComments';

interface QueryParams {
    reportId: number;
}

export const useGetReportComments = (params: QueryParams) => {
    return useQuery({
        queryKey: ['getReportComments', params],
        queryFn: () => queryFn(params),
    });
};
